import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

// state
const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getListProfileData: state => state.code
}

// actions
const actions = {
  async listProfile ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          }
        }
      })
      commit('LISTPROFILE_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listProfile, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LISTPROFILE_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTPROFILE_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTPROFILE_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTPROFILE_REQUEST_SUCCEED' (state, payload) {
    state.code = payload
    state.error = false
    state.errorDescription = ''
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
